import { Button, Form, FormProps, InputNumber } from "antd";
import React from "react";
import { update } from "../firebase";
import { chfsToStripeAmount } from "../utils";
import { PotType } from "./pot";

const PotForm: React.FC<{ amount?: number, close: () => void }> = ({ amount, close }) => {
  const onFinish: FormProps<PotType>["onFinish"] = async (values) => {
    await update("pot", "global", { amount: chfsToStripeAmount(values.amount) || 0 });
    close();
  };

  return (
    <>
      <Form
        key="pot"
        name="pot"
        initialValues={{
          amount,
        }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Montant actuel"
          name="amount"
          rules={[{ required: true, message: "Champ requis" }]}
        >
          <InputNumber />
        </Form.Item>

        <Form.Item style={{ textAlign: "center" }}>
          <Button type="primary" htmlType="submit">
            Sauvegarder
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default PotForm;
